import { render } from "./DetalhesBug.vue?vue&type=template&id=671d4ce7"
import script from "./DetalhesBug.vue?vue&type=script&lang=js"
export * from "./DetalhesBug.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__